import AdminDrugsContainer from './drugs-container';

export default AdminDrugsContainer;